<template>
  <v-form
    v-if='person'>
    <v-card>
      <v-card-title
        class="headline grey lighten-2"
        primary-title>Edit family member</v-card-title>

      <v-card-text>
        <v-text-field
          @focus="$event.target.select()"
          v-model="person.name"
          :label="`What is this person's name?`"></v-text-field>

        <AgeQuestRel
          :data="data"
          :modifyIndex="indexNum"/>

        <GenderQuest
          :modifyData="data"
          :modifyIndex="indexNum"/>

        <div
          v-if='["niece/nephew", "paternal cousin", "maternal cousin", "grandchild", "great grandchild"].includes(this.data[this.indexNum].relationship)'>
          <span>Who is this person's father or mother?</span>

          <v-select
            placeholder="Parents of this person"
            v-model="data[indexNum].parents"
            :items="parentsList()"
            required></v-select>
        </div>

        <HalfSib
          v-if="!imediates.includes(data[indexNum].relationship) && data[indexNum].relationship !== 'child' && data[indexNum].relationship !== ''"
          :modifyData="data"
          :modifyIndex="indexNum"/>

        <DeathQuest
          :data="data"
          :modifyIndex="indexNum"/>

        <AddtionalQuestion  :data="data"
        :modifyIndex="indexNum" />
        <span><v-icon
      slot="icon"
      color="blue"
      size="25"
    >
      info
    </v-icon>Please add any health conditions that this person has or has had that you are aware of. Provide as much information as you can, and don’t worry if there are some details missing.</span>
        <CondTest
          :modifyData="data"
          :modifyIndex="indexNum"/>

        <v-textarea
          v-model="person.notes"
          outline
          name="input-7-4"
          label="Comments"
          value></v-textarea>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          text
          @click="save()">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import AddtionalQuestion from "./additonalQuest"
import { mapFields } from "vuex-map-fields";
import GenderQuest from "./GenderQuest";
import CondTest from "./CondTest";
import AgeQuestRel from "./AgeQuestRel";
import HalfSib from "./HalfSib";
import DeathQuest from "./DeathQuest";

export default {
  components: {
    AddtionalQuestion,
    GenderQuest,
    CondTest,
    AgeQuestRel,
    HalfSib,
    DeathQuest
  },
  props: {
    data: Array,
    indexNum: Number
  },
  methods: {
    save () {
      if (this.indexNum === -1) {
        this.data.push(this.person);
      } else {
        this.data[this.indexNum] = this.person;
      }
      this.data[this.indexNum] = this.person;
      this.$emit('closePersonModal')
    },
    parentsList () {
      let pList
      switch (this.data[this.indexNum].relationship) {
        case "grandchild":
          pList = this.data.filter(item => {
            return item.relationship === "child"
          }).map(function (obj) {
            return obj.name
          });
          return pList
        case "paternal cousin":
          pList = this.data.filter(item => {
            return item.relationship === "paternal uncle" || item.relationship === "paternal aunt"
          }).map(function (obj) {
            return obj.name
          });
          return pList
        case "maternal cousin":
          pList = this.data.filter(item => {
            return item.relationship === "maternal uncle" || item.relationship === "maternal aunt"
          }).map(function (obj) {
            return obj.name
          });
          return pList
        case "niece/nephew":
          pList = this.data.filter(item => {
            return item.relationship === "sibling"
          }).map(function (obj) {
            return obj.name
          });
          return pList
      }
    },
  },
  data () {
    return {
      person: null,
      fieldRules: [
        v => !!v || "this field is required"
      ],
      ageRules: [
        v => (v && v >= 0) || 'Age must be larger or equal to 0'
      ],
      imediates: [
        "self",
        "mother",
        "father",
        "maternal grandfather",
        "maternal grandmother",
        "paternal grandfather",
        "paternal grandmother",
      ],
      newPerson: {
        pid: '',
        relationship: '',
        fname: '',
        lname: '',
        name: '',
        gender: '',
        newGender: {
          legal: '',
          identity: '',
          assigned: ''
        },
        isLiving: true,
        age: 0,
        dob: '',
        conditions: [],
        femaleOnly: [],
        notes: ''
      }
    }
  },
  mounted () {
    if (this.indexNum !== -1) {
      this.person = this.data[this.indexNum]
    } else {
      this.person = this.newPerson
    }
  },
  watch: {
    indexNum: function (newVal) {
      this.person = this.data[newVal]
    }
  },
  computed: {
    ...mapFields("patientQuestion", [
      "genderList",
      "snackbar",
      "errorText",
    ])
  }
}
</script>
